<template>
	<v-data-iterator
		:items="items"
		:rows-per-page-items="[params.limit]"
		:pagination.sync="pagination"
		hide-actions
		row
		wrap
		class="mx-0 fill-height"
		content-tag="v-layout"
	>
		<template v-slot:no-data>
			<v-flex v-if="!loading" xs12 class="pa-5 grey lighten-3 primary--text">
				No hay resultados
			</v-flex>
			<v-flex v-if="loading" xs12 class="pa-5 grey lighten-3 primary--text">
				Cargando datos
			</v-flex>
		</template>
		<template v-slot:item="element">
			<v-flex
				:class="[{'rowing d-flex': viewList.rowing}, {'xs12 sm6 md6 lg4 xl3': !viewList.rowing}, {'xs12': viewList.rowing}]"
			>
				<v-card class="fill-height my-elevation-2 white">
					<v-toolbar
						v-if="!viewList.rowing"
						class="navbartext navbartext--text elevation-0 toolbarCard"
						:style="{'position': 'relative'}"
						:height="75"
					>
					
						<div class="bodybackground--text subheading font-weight-bold">{{ element.item[titleCard.name] }} {{ element.item['apellidos'] }}</div>
						<v-spacer></v-spacer>
						<v-toolbar-items>
							<v-hover v-for="(v, d) in actions" :key="d">
								<v-btn
									slot-scope="{ hover }"
									:title="v.name"
									:class="['action-card-btns', `${ hover ? v.color : v.color}`]"
									@click="v.type == 'action' ? v.action(element.item.id,element.item.nombre) : null"
									:to="v.type == 'link' ? {...v.to, params: {id: element.item.id}} : null"
									:style="!viewList.rowing ? {'right': `${(40*d)+16}px`, 'margin-right': `${d >= 1 ? 10 : 0}px !important`} : null"
									:absolute="!viewList.rowing"
									fab
									:depressed="true"
									:bottom="!viewList.rowing"
									:right="!viewList.rowing"
									small
								>
									<v-icon size="20">
										{{ v.icon }}
									</v-icon>
								</v-btn>
							</v-hover>
						</v-toolbar-items>
					</v-toolbar>
					
					<v-card-text class="pa-0">
						<v-container
							:class="[{'py-2': viewList.rowing}]"
							class="grid-list-md"
						>
							<!-- Card List -->
							<v-layout row wrap v-if="!viewList.rowing">
								<template v-for="(val, i) in datos">	
									<v-flex
										:class="val.classes.card"
										:key="i" v-if="val.id != titleCard.name"
									>
										<div>
											<div class="third--text text--lighten-1 caption">
												{{ val.name }}
											</div>
											<div class="subheading navbartext--text text--darken-2 font-weight-bold text-truncate">
												
												{{ (val.type == "date" )?  formatDate(element.item[val.id]) : element.item[val.id] }}
											</div>
										</div>
									</v-flex>
								</template>
								<v-flex v-if="element.item.auth"
									class="xs12 sm12 md12 lg12 xl6">
									<div class="third--text text--lighten-1 caption">
										Fecha último acceso
									</div>
									<div class="subheading navbartext--text text--darken-2 font-weight-bold text-truncate">
									{{formatDateHour(element.item.auth.metadata.lastLoginAt)}}
									</div>
								</v-flex>
							</v-layout>
							<!-- Table List -->
							<v-layout row wrap justify-space-between align-center v-else>
								<template v-for="(val, i) in datos">	
									<v-flex
										:class="val.classes.list"
										:key="i"
									>
										<div class="third--text text--lighten-1 caption" v-if="$vuetify.breakpoint.xs">
											{{ val.name }} asdasd
										</div>
										<div class="body-1 navbartext--text">
											<div :title="val.truncate ? element.item[val.id] : false" :class="[`${!$store.state.menu.isMobile ? 'text-truncate' : ''}`]">
												{{ (val.type == "date" )?  formatDate(element.item[val.id]) : element.item[val.id] }}
											</div>
										</div>
									</v-flex>
								</template>
								<div class="third--text text--lighten-1 caption" v-if="$vuetify.breakpoint.xs">
									{{ nombre }}
								</div>
								<div class="body-1 navbartext--text" v-if="element.item.auth">
								{{formatDateHour(element.item.auth.metadata.lastLoginAt)}}
								</div>
									
								<!-- Acciones -->
								<v-flex class="text-lg-right grow">
									<div class="d-flex-inline">
										<v-hover v-for="(v, d) in actions" :key="d" >
											<v-btn
												:title="v.name"
												slot-scope="{ hover }"
												class="ma-0 pa-0 action-list-btns"
												:color="hover ? v.color : v.color"
												@click="v.type == 'action' ? v.action(element.item.id,element.item.nombre) : null"
												:to="v.type == 'link' ? {...v.to, params: {id: element.item.id}} : null"
												:style="!viewList.rowing ? {'right': `${(40*d)+16}px`, 'margin-right': `${d >= 1 ? 10 : 0}px !important`} : {'float': 'right'}"
												:absolute="!viewList.rowing"
												icon
												flat
												:ripple="false"
												:bottom="!viewList.rowing"
												:right="!viewList.rowing"
											>
												<v-icon size="20">
													{{ v.icon }}
												</v-icon>
											</v-btn>
										</v-hover>
									</div>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card-text>
				</v-card>
			</v-flex>
		</template>
	</v-data-iterator>
	
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment' 

export default {
	props: ['datos', 'actions', 'results', 'titleCard'],
	data() {
		return {
			pagination: {
				rowsPerPage: -1 // -1 for All",
			}
		}
	},
	watch: {
		results(e) {
			return this.pagination.rowsPerPage = e
		}
	},
	computed: {
		...mapState('listItems',['items', 'viewList', 'searching', 'params']),
		...mapState(['loading'])
	},
	created() {
		this.pagination.rowsPerPage = this.params.limit
	},
	methods: {
		formatDate(date){
			if (date.seconds) {
        return moment.unix(date.seconds).format('DD/MM/YYYY')
      } else if(date) {
        return moment(date).format('DD/MM/YYYY')
      }			
		},
		formatDateHour(date){
			if (date.seconds) {
				return moment.unix(date.seconds).format('DD/MM/YYYY HH:MM')
			} else if(date) {
				return moment(date).format('DD/MM/YYYY HH:MM')
			}			
		}
	}
}
</script>

<style lang="scss">
.toolbarCard > div {
	align-items: flex-end;
	padding-bottom: 24px;
}
/* .hoverbackground {
	background-color: rgba(255,255,255,0.6) !important;
	transition: background-color ease .8s;
	&:hover {
		background-color: rgba(255,255,255,1) !important;
	}
} */
.action-list-btns {
	&:before {
		content: initial;
	}	
}
</style>
